// third-party
import { combineReducers } from "redux";

// project imports
import globalReducer from "./slices/global";
import authReducer from "./slices/auth";
import unitsReducer from "./slices/units";
import buildingReducer from "./slices/building";
import equipReducer from "./slices/equip";
import productsReducer from "./slices/products";

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  global: globalReducer,
  auth: authReducer,
  units: unitsReducer,
  building: buildingReducer,
  equip: equipReducer,
  products: productsReducer
});

export default reducer;
